module.exports = __webpack_public_path__ + "img/protect2.d9323195.png";